export default __webpack_public_path__ + "static/media/media.06aba2b3.jpg";